// components/Ticks.js
export default function Ticks({ status, onMedia = false }) {
  if (!status) return null;

  const colour =
    status === "seen"
      ? "text-[#53bdeb]"
      : onMedia
      ? "text-white/80"
      : "text-[#8696a0]";

  return (
    <svg
      viewBox="0 0 18 11"
      width="16"
      height="11"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={colour}
      aria-label={status}
    >
      <path d="M1 5.8 4.2 9 10.5 1.5" />
      {status !== "sent" && <path d="M5.5 5.8 8.7 9 15 1.5" />}
    </svg>
  );
}